import ExternalLink from "./ExternalLink";

export { ExternalLink };
